export default __webpack_public_path__ + "static/media/USTw.54af3ce4.png";